import anime from 'animejs/lib/anime.es.js';
window.anime = anime;